module.exports = __webpack_public_path__ + "static/media/left.073d496c.ts";